var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRxBellIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 27.597c1.579 0 2.87-1.242 2.87-2.76H9.33c0 1.518 1.291 2.76 2.87 2.76zm9.33-8.28V11.73c0-4.278-3.015-7.727-7.177-8.693V2.07C14.353.966 13.348 0 12.2 0c-1.148 0-2.153.966-2.153 2.07v.966c-4.162.966-7.176 4.415-7.176 8.693v7.589L0 22.078v1.38h24.4v-1.38l-2.87-2.76z",
    fill: "#1d252d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRxBellIcon);
export default __webpack_public_path__ + "static/media/rx_bell_icon.aa1eab00f4cc845204fe8a4cad736777.svg";
export { ForwardRef as ReactComponent };